import { render, staticRenderFns } from "./customize.vue?vue&type=template&id=14c1f1bf&scoped=true"
import script from "./customize.vue?vue&type=script&lang=ts"
export * from "./customize.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c1f1bf",
  null
  
)

export default component.exports